// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host[class*='mt-'] .card {
  margin-top: inherit !important;
}
:host[class*='mb-'] .card {
  margin-bottom: inherit !important;
}

.card {
  margin-top: 10px !important;
  border: none !important;
  border-radius: 8px !important;
}

.card-header {
  padding: 6px 15px !important;
  border-radius: 8px 8px 0px 0px !important;
  background-color: var(--app-surface);
  border-bottom: solid 0.75px var(--app-legacy-card-divider);
}

.card-title {
  margin: 0;
}

.card-header-layout {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
}

.card-header-content {
  flex: 1 1 auto;
  min-width: 0;
}

.card-header-controls {
  order: -1;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.card-header-status {
  grid-column: 1;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  gap: 3px;
  }

.card-header-actions {
  grid-column: 2;
  display: flex;
  justify-content: flex-end;
  min-width: 0;
  gap: 8px;
}

.card-body {
  padding: 6px 15px !important;
}

.card-body ::ng-deep .form-group {
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin: 0 0 10px !important;
}

.card-body ::ng-deep .row:has(> .form-group) {
  margin-right: -15px !important;
  margin-left: -15px !important;
}

.card-body ::ng-deep .row > .form-group {
  padding-right: 15px !important;
  padding-left: 15px !important;
}

.card-body ::ng-deep small {
  margin-bottom: -2px !important;
}

.card-footer {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 6px 15px !important;
  border: none !important;
  border-radius: 0px 0px 8px 8px !important;
  background-color: var(--app-surface);
}

.icon-card-header {
  font-size: var(--app-font-size-22px);
  text-decoration: none;
}

.icon-card-header.disabled {
  opacity: 0.5 !important;
}

.button-card-header.disabled {
  opacity: 0.5 !important;
}

.no-after::after {
  display: none;
}

.btn:not(:disabled):not(.disabled):hover {
  cursor: pointer;
}

/* Estilos para dropdown items desabilitados */
.dropdown-item.disabled {
  cursor: not-allowed !important;
  opacity: 0.5;
  background-color: transparent !important;
}

.dropdown-item.disabled:hover {
  background-color: transparent !important;
  color: inherit !important;
}

/* Neutraliza o :active/:focus do Bootstrap para manter visual consistente no clique */
.dropdown-item:active,
.dropdown-item:focus {
  background-color: var(--app-legacy-dropdown-focus) !important;
  outline: none;
}

/* Accordion dentro do dropdown (item com children) */
.dropdown-item-accordion {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.dropdown-accordion-chevron {
  transition: transform 0.2s ease;
  font-size: var(--app-font-size-18px);
}

.dropdown-accordion-chevron.expanded {
  transform: rotate(90deg);
}

.dropdown-accordion-body {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.25s ease;
}

.dropdown-accordion-body.expanded {
  max-height: 200px;
}

.dropdown-item-child {
  padding-left: 2rem;
}

@media (min-width: 768px) {
  .card-header-layout {
    flex-direction: row;
  align-items: center;
  }

  .card-header-content {
    min-width: 50%;
  }

  .card-header-controls {
    order: 0;
    position: relative;
    top: -2px;
  display: flex;
    flex: 0 1 auto;
  flex-direction: column;
    align-items: flex-end;
    max-width: 50%;
    margin-left: auto;
    gap: 2px;
  }

  .card-header-status {
    white-space: nowrap;
  }
}

.card-header-actions > * {
  min-width: 0;
  flex-shrink: 1;
}

.card-header-actions .button-card-header {
  max-width: 100%;
  white-space: normal;
}

.card-footer .btn-footer-compact {
  text-align: center;
}

@media (max-width: 640px) {
  :host {
    display: block;
    margin-left: 8px;
    margin-right: 8px;
  }
}

.card-header { border-top: 1.5px solid var(--app-primary) !important; }
.card-header-actions, .dropdown-item { color: var(--app-primary); }
.card-body { max-width: 100%; max-height: 100%; }
.button-card-header.btn-primary { border: none; }
.app-dropdown-label { font-style: normal; }
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/card/card.component.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,yCAAyC;EACzC,oCAAoC;EACpC,0DAA0D;AAC5D;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,SAAS;EACT,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;EACR;;AAEF;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,uBAAuB;EACvB,yCAAyC;EACzC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,8BAA8B;EAC9B,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA,sFAAsF;AACtF;;EAEE,6DAA6D;EAC7D,aAAa;AACf;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;EACrB,mBAAmB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,QAAQ;IACR,kBAAkB;IAClB,SAAS;EACX,aAAa;IACX,cAAc;EAChB,sBAAsB;IACpB,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA,eAAe,qDAAqD,EAAE;AACtE,uCAAuC,yBAAyB,EAAE;AAClE,aAAa,eAAe,EAAE,gBAAgB,EAAE;AAChD,kCAAkC,YAAY,EAAE;AAChD,sBAAsB,kBAAkB,EAAE","sourcesContent":[":host[class*='mt-'] .card {\n  margin-top: inherit !important;\n}\n:host[class*='mb-'] .card {\n  margin-bottom: inherit !important;\n}\n\n.card {\n  margin-top: 10px !important;\n  border: none !important;\n  border-radius: 8px !important;\n}\n\n.card-header {\n  padding: 6px 15px !important;\n  border-radius: 8px 8px 0px 0px !important;\n  background-color: var(--app-surface);\n  border-bottom: solid 0.75px var(--app-legacy-card-divider);\n}\n\n.card-title {\n  margin: 0;\n}\n\n.card-header-layout {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 8px;\n}\n\n.card-header-content {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.card-header-controls {\n  order: -1;\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.card-header-status {\n  grid-column: 1;\n  display: inline-flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 3px;\n  }\n\n.card-header-actions {\n  grid-column: 2;\n  display: flex;\n  justify-content: flex-end;\n  min-width: 0;\n  gap: 8px;\n}\n\n.card-body {\n  padding: 6px 15px !important;\n}\n\n.card-body ::ng-deep .form-group {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n  margin: 0 0 10px !important;\n}\n\n.card-body ::ng-deep .row:has(> .form-group) {\n  margin-right: -15px !important;\n  margin-left: -15px !important;\n}\n\n.card-body ::ng-deep .row > .form-group {\n  padding-right: 15px !important;\n  padding-left: 15px !important;\n}\n\n.card-body ::ng-deep small {\n  margin-bottom: -2px !important;\n}\n\n.card-footer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 6px 15px !important;\n  border: none !important;\n  border-radius: 0px 0px 8px 8px !important;\n  background-color: var(--app-surface);\n}\n\n.icon-card-header {\n  font-size: var(--app-font-size-22px);\n  text-decoration: none;\n}\n\n.icon-card-header.disabled {\n  opacity: 0.5 !important;\n}\n\n.button-card-header.disabled {\n  opacity: 0.5 !important;\n}\n\n.no-after::after {\n  display: none;\n}\n\n.btn:not(:disabled):not(.disabled):hover {\n  cursor: pointer;\n}\n\n/* Estilos para dropdown items desabilitados */\n.dropdown-item.disabled {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n  background-color: transparent !important;\n}\n\n.dropdown-item.disabled:hover {\n  background-color: transparent !important;\n  color: inherit !important;\n}\n\n/* Neutraliza o :active/:focus do Bootstrap para manter visual consistente no clique */\n.dropdown-item:active,\n.dropdown-item:focus {\n  background-color: var(--app-legacy-dropdown-focus) !important;\n  outline: none;\n}\n\n/* Accordion dentro do dropdown (item com children) */\n.dropdown-item-accordion {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n}\n\n.dropdown-accordion-chevron {\n  transition: transform 0.2s ease;\n  font-size: var(--app-font-size-18px);\n}\n\n.dropdown-accordion-chevron.expanded {\n  transform: rotate(90deg);\n}\n\n.dropdown-accordion-body {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.25s ease;\n}\n\n.dropdown-accordion-body.expanded {\n  max-height: 200px;\n}\n\n.dropdown-item-child {\n  padding-left: 2rem;\n}\n\n@media (min-width: 768px) {\n  .card-header-layout {\n    flex-direction: row;\n  align-items: center;\n  }\n\n  .card-header-content {\n    min-width: 50%;\n  }\n\n  .card-header-controls {\n    order: 0;\n    position: relative;\n    top: -2px;\n  display: flex;\n    flex: 0 1 auto;\n  flex-direction: column;\n    align-items: flex-end;\n    max-width: 50%;\n    margin-left: auto;\n    gap: 2px;\n  }\n\n  .card-header-status {\n    white-space: nowrap;\n  }\n}\n\n.card-header-actions > * {\n  min-width: 0;\n  flex-shrink: 1;\n}\n\n.card-header-actions .button-card-header {\n  max-width: 100%;\n  white-space: normal;\n}\n\n.card-footer .btn-footer-compact {\n  text-align: center;\n}\n\n@media (max-width: 640px) {\n  :host {\n    display: block;\n    margin-left: 8px;\n    margin-right: 8px;\n  }\n}\n\n.card-header { border-top: 1.5px solid var(--app-primary) !important; }\n.card-header-actions, .dropdown-item { color: var(--app-primary); }\n.card-body { max-width: 100%; max-height: 100%; }\n.button-card-header.btn-primary { border: none; }\n.app-dropdown-label { font-style: normal; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
